var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-text',[_c('span',{class:_vm.envClass},[_vm._v(_vm._s(_vm.envName))]),_vm._v(" "),_c('span',{staticClass:"version"},[_vm._v(_vm._s(_vm.GAME_VERSION)+" ("+_vm._s(_vm.REVISION_HASH)+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }